module.exports = __webpack_public_path__ + "img/logo.219fdc47.png";